import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'shared/domain';

export type ImportGuidelineParams = {
  uniqueId: string;
  guidelineName: string;
  source: string;
  guidelineOrganisationId?: string;
};

export type ClusterInvitationParams = {
  hash: string;
};

export const redirectBasedOnPermissions = () => {
  const router = inject(Router);
  const userService = inject(UserService);

  if (userService.isCurrentUserInClinicalPartnerRole()) {
    return router.createUrlTree(['/smartbook']);
  }

  return router.createUrlTree(['/admin/components']);
};
